import React from 'react';
import { Box, LinearProgress, Paper, SxProps, Theme } from '@mui/material';

/**
 * The one filter row used across the app: an outlined card holding the
 * filters, with a hairline progress bar along its foot while results load.
 * `sx` lets a page pin it (position: sticky) or adjust spacing.
 */
const FilterBar: React.FC<{ loading?: boolean; children: React.ReactNode; sx?: SxProps<Theme> }> = ({ loading, children, sx }) => (
  <Paper variant="outlined" sx={[{ position: 'relative', overflow: 'hidden', borderRadius: 2.5, px: 2, py: 1.5, mb: 2.5 }, ...(Array.isArray(sx) ? sx : [sx])]}>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, alignItems: 'center' }}>{children}</Box>
    {loading && <LinearProgress sx={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: 2 }} />}
  </Paper>
);

export default FilterBar;
